import { render, staticRenderFns } from "./PointSettings.vue?vue&type=template&id=78f7f8f5"
import script from "./PointSettings.vue?vue&type=script&lang=js"
export * from "./PointSettings.vue?vue&type=script&lang=js"
import style0 from "./PointSettings.vue?vue&type=style&index=0&id=78f7f8f5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports